import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';

/**
 * @todo The quality of this component is relatively poor, and could be improved
 * as part of a future improvement work.
 */
// needs props maxPage, currentPage, nextFunction, prevFunction
class GridPagination extends Component {
  constructor(props) {
    super(props);

    this.pageChange = this.pageChange.bind(this);
  }

  pageChange(event) {
    this.props.setPage(parseInt(event.target.value, 10) - 1);
  }

  render() {
    let previous = '';
    let next = '';

    if (this.props.currentPage > 0) {
      previous = (
        <button
          type="button"
          onClick={this.props.previous}
          style={
            this.props.useGriddleStyles
              ? {
                  color: '#222',
                  border: 'none',
                  background: 'none',
                  margin: '0 0 0 10px',
                }
              : null
          }
        >
          {this.props.previousIconComponent}
          {this.props.previousText}
        </button>
      );
    }

    if (this.props.currentPage !== this.props.maxPage - 1) {
      next = (
        <button
          type="button"
          onClick={this.props.next}
          style={
            this.props.useGriddleStyles
              ? {
                  color: '#222',
                  border: 'none',
                  background: 'none',
                  margin: '0 10px 0 0',
                }
              : null
          }
        >
          {this.props.nextText}
          {this.props.nextIconComponent}
        </button>
      );
    }

    let leftStyle = null;
    let middleStyle = null;
    let rightStyle = null;

    if (this.props.useGriddleStyles === true) {
      const baseStyle = {
        float: 'left',
        minHeight: '1px',
        marginTop: '5px',
      };

      rightStyle = assign({ textAlign: 'right', width: '34%' }, baseStyle);
      middleStyle = assign({ textAlign: 'center', width: '33%' }, baseStyle);
      leftStyle = assign({ width: '33%' }, baseStyle);
    }

    const options = [];

    for (let i = 1; i <= this.props.maxPage; i++) {
      options.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }

    return (
      <div style={this.props.useGriddleStyles ? { minHeight: '35px' } : null}>
        <div className={this.props.previousClassName} style={leftStyle}>
          {previous}
        </div>
        <div className="griddle-page" style={middleStyle}>
          <select
            value={this.props.currentPage + 1}
            onChange={this.pageChange}
            onBlur={this.pageChange}
          >
            {options}
          </select>{' '}
          / {this.props.maxPage}
        </div>
        <div className={this.props.nextClassName} style={rightStyle}>
          {next}
        </div>
      </div>
    );
  }
}

GridPagination.defaultProps = {
  maxPage: 0,
  nextText: '',
  previousText: '',
  currentPage: 0,
  useGriddleStyles: true,
  nextClassName: 'griddle-next',
  previousClassName: 'griddle-previous',
  nextIconComponent: null,
  previousIconComponent: null,
};

GridPagination.propTypes = {
  setPage: PropTypes.func,
  next: PropTypes.func,
  currentPage: PropTypes.number,
  maxPage: PropTypes.number,
  previous: PropTypes.string,
  useGriddleStyles: PropTypes.bool,
  previousIconComponent: PropTypes.string,
  previousText: PropTypes.string,
  nextText: PropTypes.string,
  nextIconComponent: PropTypes.string,
  previousClassName: PropTypes.string,
  nextClassName: PropTypes.string,
};

export { GridPagination };
